module.exports = __webpack_public_path__ + "static/media/venus.e6594423.png";